import { Injectable } from '@angular/core';
import { CampaignService } from '../campaign.service';

/* RxJs */
import { Observable, of } from 'rxjs';
import { mergeMap, map, catchError, tap } from 'rxjs/operators';

/* NgRx */
import * as liveCampaignActions from './live-campaign.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { CampaignListTab } from '../campaign';

@Injectable()
export class LiveCampaignEffects {
    constructor(private _campaignService: CampaignService,
        private _actions$: Actions) { }

    @Effect()
    loadLiveCampaignSummaries$: Observable<Action> = this._actions$.pipe(
        ofType(liveCampaignActions.LiveCampaignActionTypes.loadCampaigns),
        map((action: liveCampaignActions.LoadCampaigns) => action.payload),
        mergeMap((requestInfo) =>
            this._campaignService.getCampaigns(CampaignListTab.live,
                    requestInfo.pagination.index, requestInfo.pagination.size,
                    requestInfo.sorting.fieldName, requestInfo.sorting.direction).pipe(
                map(campaigns => (new liveCampaignActions.LoadCampaignsSuccess(campaigns))),
                catchError(err => of(new liveCampaignActions.LoadCampaignsFail('Error laoding live campaigns')))
            )
        )
    );
}
